import { render, staticRenderFns } from "./GenerateContent.vue?vue&type=template&id=2be32f5e"
import script from "./GenerateContent.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateContent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports